import React, { useState } from "react";
import {
  Button,
  Row,
  Col,
  InputGroup,
  Form,
  Card,
  Table,
  Modal,
  Container,
  Image,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import inventory from "../data/inventory";
import PageTitle from "../components/PageTitle";
import { BiDotsHorizontalRounded, BiSearch } from "react-icons/bi";
import { FeaturedCardWidget } from "../components/Widgets";

import inventoryImg from "../assets/img/icons/inventory-card-img.svg";
import inventoryIcon from "../assets/img/icons/inventory-card-icon.svg";
import costIcon from "../assets/img/icons/cost-card-icon.svg";
import valueIcon from "../assets/img/icons/value-card-icon.svg";

// ADD INVENTORY MODAL

const AddInventoryModal = (props) => {
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Product
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="px-0 py-3">
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Item #</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Bin Location</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Label>Vendor</Form.Label>
                <Form.Select>
                  <option defaultChecked>Auto Zone</option>
                  <option value="1">Napa</option>
                  <option value="2">Auto Parts</option>
                </Form.Select>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Retail</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Qty</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={props.onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={props.onHide}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Inventory = () => {
  const [modalShow, setModalShow] = useState(false);
  const [inventoryList, setInventoryList] = useState("");
  const costSum = inventory.reduce(
    (total, currentItem) => (total = total + currentItem.cost),
    0
  );
  const retailSum = inventory.reduce(
    (total, currentItem) => (total = total + currentItem.retail),
    0
  );

  const qtySum = inventory.reduce(
    (total, currentItem) => (total = total + currentItem.qty),
    0
  );

  const costTotal = costSum * qtySum;

  const retailTotal = retailSum * qtySum;

  return (
    <>
      <PageTitle title="Inventory" />
      <Row className="mb-4">
        <Col md={3}>
          <FeaturedCardWidget
            title="Total Parts"
            value={inventory.length}
            icon={inventoryIcon}
            bgImg={inventoryImg}
            badge="24 To Reorder"
          />
        </Col>
        <Col md={3}>
          <FeaturedCardWidget
            title="Total Cost"
            value={`$ ${costTotal}`}
            icon={costIcon}
          />
        </Col>
        <Col md={3}>
          <FeaturedCardWidget
            title="Total Value"
            value={`$ ${retailTotal}`}
            icon={valueIcon}
          />
        </Col>
      </Row>

      <Card className=" table-wrapper table-responsive ">
        <Card.Body className="card-body-table">
          <Row className="d-flex justify-content-between">
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <InputGroup className="search-input">
                    <InputGroup.Text>
                      <BiSearch />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={(event) => {
                        setInventoryList(event.target.value);
                      }}
                    />
                  </InputGroup>
                </Col>
                <Col md={3}>
                  <Form.Select>
                    <option value="Show All">Show All</option>
                    <option value="Part to Reorder">Part to Reorder</option>
                    <option value="Oil Filters">Oil Filters</option>
                    <option value="Batteries">Batteries</option>
                    <option value="Wipers">Wipers</option>
                    <option value="Tires">Tires</option>
                    <option value="Brake Pads">Brake Pads</option>
                    <option value="Air Filter">Air Filter</option>
                  </Form.Select>
                </Col>
              </Row>
            </Col>

            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => setModalShow(true)}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Part
              </Button>
            </Col>
          </Row>

          <Table responsive className="user-table align-items-center mt-4">
            <thead>
              <tr>
                <th>Name</th>
                <th>Item #</th>
                <th>Vendor</th>
                <th>Bin Location</th>
                <th>Cost</th>
                <th>Retail</th>
                <th>Qty</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {inventory
                .filter((i) => {
                  if (inventoryList === "") {
                    return true;
                  }
                  return (
                    i.name
                      .toLocaleLowerCase()
                      .includes(inventoryList.toLocaleLowerCase()) ||
                    i.desc
                      .toLocaleLowerCase()
                      .includes(inventoryList.toLocaleLowerCase())
                  );
                })
                .map((i) => (
                  <tr key={i.key}>
                    <td>
                      <span className="d-flex align-items-center gap-2">
                        <Image src={i.image} height={50} />
                        <div>
                          <div className="fw-bold ">{i.name}</div>
                          <div>{i.desc}</div>
                        </div>
                      </span>
                    </td>
                    <td>
                      <span>
                        <div>{i.itemNumber}</div>
                      </span>
                    </td>
                    <td>
                      <span>
                        <div>{i.vendor}</div>
                      </span>
                    </td>
                    <td>
                      <span>
                        <div>{i.binLocation}</div>
                      </span>
                    </td>
                    <td>
                      <span>{i.cost}</span>
                    </td>
                    <td>
                      <span>{i.retail}</span>
                    </td>
                    <td>
                      <span>{i.qty}</span>
                    </td>
                    <td className="text-right fs-3 text-muted">
                      <span>
                        <BiDotsHorizontalRounded />
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <AddInventoryModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
      />
    </>
  );
};

export default Inventory;
